import { sendToApi } from 'api/client'
import { Doc, ArticleFlat } from 'types'
import { ChangeSet } from 'prosemirror-changeset'
import { PaginatedApiClient } from 'api/PaginatedApiClient'

export type ArticlesView = {
  articles: Doc[]
}

export const VersionClient = {
  getRelatedArticles: async (id: string) => {
    return sendToApi<ArticlesView>(`/articles/${id}/comparable_articles`)
  },

  getMergedBranches: async (id: string, withStatus: boolean = false) => {
    return sendToApi<ArticlesView>(`/articles/${id}/merged_branches?with_status=${withStatus}`)
  },

  getCopies: async (id: string, withLatestEventId: boolean = false, all: boolean = true) => {
    return sendToApi<ArticlesView>(`/articles/${id}/copies`, {
      params: { with_latest_event_id: withLatestEventId, all },
    })
  },

  createDocVersion: async (
    articleId: string,
    versionName: string,
    emoji?: string | null,
    iterateDuplicateName: boolean = true,
    version?: number,
    destinationFolderId?: string | null,
    shareWithSamePeople: boolean = false,
  ) => {
    return sendToApi<{ article: ArticleFlat }>(`/articles/${articleId}/branch_out`, {
      method: 'POST',
      body: {
        branch: { version_name: versionName },
        emoji,
        iterate_duplicate_name: iterateDuplicateName,
        version,
        destination_folder_id: destinationFolderId,
        share_with_same_people: shareWithSamePeople,
      },
    })
  },

  getBranches: (articleId: string, withStatus: boolean = false, withPendingReview: boolean = false) => {
    return new PaginatedApiClient<ArticlesView>(
      `/articles/${articleId}/branches?with_latest_event_id=true&with_status=${withStatus}&with_pending_review=${withPendingReview}`,
    )
  },

  getUserBranches: async (articleId: string) => {
    return sendToApi<ArticlesView>(`/articles/${articleId}/user_branches`)
  },

  getChangesFromParent: async (articleId: string) => {
    return sendToApi<{ changeset: ChangeSet; version: number; initialState: any }>(
      `/articles/${articleId}/changes_from_parent`,
    )
  },

  getVersionInfo: async (articleId: string) => {
    return sendToApi<{
      article: {
        id: string
        current_version: number
        master_branch_version?: number
        branched_at_version?: number
      }
    }>(`/articles/${articleId}/version_info`)
  },

  getRevision: async (articleId: string, fromVersion: number, toVersion: number) => {
    return sendToApi(`/articles/${articleId}/revisions/${fromVersion}..${toVersion}`)
  },

  automergeBranch: async (articleId: string, mergeNote: string, clientUuid: string) => {
    return sendToApi(`/articles/${articleId}/automerge`, {
      method: 'POST',
      body: { general_comment: mergeNote, client_uuid: clientUuid },
    })
  },
}
